// extracted by mini-css-extract-plugin
module.exports = {"message":"styles_message__cPLVP system_captionL__E1FNu"};